import awsExports from '../aws-exports';

const isDev = awsExports.aws_project_stage === 'dev';

function exposeIfDev(items = {}, exposeAtPath = '___') {
    if (isDev) {
        if (!window[exposeAtPath]) {
            window[exposeAtPath] = {};
        }
        Object.keys(items).forEach(k => {
            window[exposeAtPath][k] = items[k];
        });
    }
}

function doIfDev(fn, returnValueIfNotDev = null) {
    if (isDev) {
        return fn();
    } else {
        return returnValueIfNotDev;
    }
}

function wait(durationInMs) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve(durationInMs);
        }, durationInMs)
    });
}

export {
    exposeIfDev,
    doIfDev,
    isDev,
    wait,
}
